import type { AppPaddleButtonState } from "./AppPaddleButton.types";

export const useAppPaddleButtonDataIsFocusable = (
  state: AppPaddleButtonState
): AppPaddleButtonState => {
  state.root["data-is-focusable"] = "false";

  return state;
};
